// extracted by mini-css-extract-plugin
export var cardIcon = "_97-5";
export var cardIconUnframed = "_97-9";
export var checkboxCard = "_97-0";
export var checkboxCardSelected = "_97-4";
export var disabled = "_97-2";
export var interactive = "_97-1";
export var outerBorder = "_97-3";
export var spacerMedium = "_97-8";
export var spacerSmall = "_97-7";
export var spacerXsmall = "_97-6";